export default __webpack_public_path__ + "static/media/reports.e6abcc5d.svg";